import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dialog-edit-image',
  templateUrl: './dialog-edit-image.component.html',
  styleUrls: ['./dialog-edit-image.component.scss'],
  standalone: false,
})
export class DialogEditImageComponent implements OnInit {
  translate = inject(TranslateService);

  private _eventChange$: Observable<File>;
  private _eventChangeObserver: Observer<File>;

  public showDialog: boolean = false;
  public result: File;

  constructor() {
    this._eventChange$ = new Observable<File>(observer => (this._eventChangeObserver = observer));
  }

  public ngOnInit() {}

  public show(): Observable<File> {
    this.result = null;
    this.showDialog = true;

    return this._eventChange$;
  }

  public onFileAdded($event: File) {
    this.result = $event;
  }

  public onSave() {
    if (this.result) {
      this._eventChangeObserver.next(this.result);
      this.showDialog = false;
    }
  }

  public onCancel() {
    this._eventChangeObserver.next(null);
    this.showDialog = false;
  }
}
